import React from 'react';
import { priceList } from '../mock';
import { useBooking } from '../hooks/useBooking';
import useSEO from '../hooks/useSEO';
import { Clock } from 'lucide-react';

const PriceList = () => {
  useSEO({
    title: 'Hinnakiri — Kavitatsioon, LPG, massaaž | Prestige Beauty & Wellness',
    description:
      'Prestige Beauty & Wellness hinnakiri: kavitatsioon, LPG Alliance kehahooldused, LPG näomassaaž, klassikaline massaaž ja kombopaketid Pärnus.',
    path: '/hinnakiri',
  });
  const openBooking = useBooking();

  return (
    <div>
      <section className="hero-bg pt-36 pb-20 px-6 text-center">
        <h1 className="section-title text-4xl md:text-5xl mt-4 fade-up">Meie hinnad</h1>
        <div className="mt-6 flex justify-center fade-up"><span className="gold-divider" /></div>
        <p className="text-brand-muted mt-8 max-w-2xl mx-auto text-sm italic leading-relaxed fade-up fade-up-delay-1">
          NB! Käesoleval lehel on toodud tavahinnad. Kampaaniate ja
          eripakkumiste ajal võivad hinnad erineda. Kõige ajakohasemad hinnad
          on alati nähtavad meie broneerimissüsteemis.
        </p>
      </section>

      <section className="bg-ivory py-20 px-6">
        <div className="max-w-4xl mx-auto space-y-16">
          {priceList.map((cat) => (
            <div key={cat.category} className="luxury-card">
              <div className="mb-8 flex flex-col items-center">
                <h2 className="price-category-heading">{cat.category}</h2>
                <div className="mt-4"><span className="gold-divider" /></div>
              </div>
              <div>
                {cat.items.map((item, i) => (
                  <div key={i} className="price-row">
                    <div className="name">{item.name}</div>
                    <div className="duration inline-flex items-center gap-1.5">
                      <Clock className="w-3.5 h-3.5 text-gold" strokeWidth={1.5} />
                      {item.duration}
                    </div>
                    <div className="price">{item.price}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}

          <div className="text-center pt-8">
            <p className="text-brand-muted italic mb-6">
              Kombopaketid ja korduvate seansside paketid pakuvad soodsamat hinda
              parimate tulemuste saavutamiseks.
            </p>
            <button className="btn-gold" onClick={openBooking}>
              Broneeri aeg
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PriceList;
